import React from 'react';
import { useRouter } from 'next/router';

import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import { SITE_ID, CONTACT_LIST_ID } from '../../comps/SignUp';
import { textTran } from '../../../config/subscribe';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { submitScribe } from '@elem/Service/next-level-power';
import { CookieDataExtendType } from 'eco-design-reliance/cookies/type';

export default function EmailCom({
    offTipsL,
    offTipsR,
    freeTipsR,
    offTips,
    freeTips,
    productValue,
    gtm_event_name = '',
    subscribeData = undefined,
}: {
    offTipsL?: string;
    offTipsR?: string;
    freeTipsR?: string;
    offTips?: string | React.ReactNode;
    freeTips?: string;
    productValue?: number[];
    gtm_event_name?: string;
    subscribeData?: CookieDataExtendType | undefined;
}) {
    const { t } = useLang('fourinone.teaser');
    const { locale }: any = useRouter();

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const fields = [
        // 站点字段
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // 订阅日期
        {
            id: '11149',
            type: 'text',
            value: dateString,
            overwrite: true,
        },
        // 产品字段
        {
            id: '11150',
            type: 'multiple',
            value: productValue,
            overwrite: false,
        },
    ];

    // 点击提交
    const clickEmarsysHandle = (data: any, callback: any) => {
        const finalData = {
            ...data,
            source: 'WEB_NEW_PRODUCT_SUB',
        };
        handleSubmit(finalData, callback);
        return true; //停止内部的接口
    };

    const handleSubmit = async (data: any, callback: any) => {
        try {
            const res = await submitScribe(locale, data, subscribeData);
            if (res?.code === '0') {
                callback && callback('success');
            } else {
                callback && callback('fail');
            }
        } catch (error: any) {}
    };

    const gtmParams = !!gtm_event_name
        ? {
              gtm_event_name,
          }
        : null;

    return (
        <div className={`${styles.EmailCom} ef-container email-component-box`}>
            <div className="EmailCom-in">
                <div className="EmailCom-l">
                    {offTipsL && <span className="EmailCom-ms1">{offTipsL}</span>}
                    {!!offTips && <span className="EmailCom-off">{offTips}</span>}
                    {!!offTipsR && <span className="EmailCom-ms1">{offTipsR}</span>}
                    {!!freeTips && <span className="EmailCom-free">{freeTips}</span>}
                    {freeTipsR && <span className="EmailCom-ms1">{freeTipsR}</span>}
                </div>
                <div className="EmailCom-r">
                    <EfEmarsysEmail
                        onBeforeSendCallback={clickEmarsysHandle}
                        contactListId={CONTACT_LIST_ID[locale]}
                        fields={fields}
                        tipsObj={textTran[locale] || textTran.us}
                        {...gtmParams}
                    />
                </div>
            </div>
        </div>
    );
}
